import React from 'react'
import { Upload, Tooltip, Modal, Button, Table, notification } from 'antd'
import { InboxOutlined, InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons' 
import { ExcelRenderer } from 'react-excel-renderer'
import _ from 'lodash'
import { withApollo } from 'react-apollo'
import EmailValidator from 'email-validator'
import moment from 'moment'

import {
    USER_LIST_COLUMN_FORMAT,
    UPLOAD_DATA_ERROR
} from '../../../../constants'
import {
    UPLOAD_USERS
} from '../../qql'

import './UploadParticipants.scss'

const { Dragger } = Upload

class UploadParticipants extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            upload_files_error: [],
            bad_data: [],
            show_bad_data_modal: false
        }
    }

    // ----------------- Graphql ------------------ //
    onUpload = (data, file_uid) => {
        const { client } = this.props
        
        return client.mutate({
            mutation: UPLOAD_USERS,
            variables: {
                data: JSON.stringify(this.filterData(data))
            }
        }).then(res => {
            this.props.uploadingSetter(false)
            this.props.uploadedSetter(true)
            this.props.uploadedSomeSetter(true)
            notification.success({
                message: 'Attendees successfully added'
            })
        })
    }
    // ----------------- End of Graphql ------------------ //

    // ----------------- FILE CHECKING ---------------- //
    checkFileType = (file) => {
        const validExts = [".xlsx", ".xls"]

        const extension = file.name.substring(file.name.lastIndexOf('.'))
        if(validExts.indexOf(extension) < 0) {
            Modal.error({
                title: 'Invalid File Type',
                content: <p><b>{file.name}</b> has invalid file type. Accepted files should have .xlsx or .xls extension</p>
            })
            
            return false
        } else {
            return true
        }
    }

    checkIfAlreadyUploaded = (file) => {
        const { uploadedFiles } = this.props
        var already_uploaded = false

        uploadedFiles.map(up => {
            if(up.name === file.name) {
                Modal.error({
                    title: 'Duplicate File Uploaded',
                    content: <p> A file named <b>{file.name}</b> has already been uploaded!</p>
                })
                already_uploaded = true
            }
        })

        return already_uploaded
    }

    checkFileFormat = (file, data) => {
        const { cols, rows } = data
        const headers = rows[0]
        var correct_format = true

        const checkHeaders = (headers) => {
            var correct = true

            headers.map((header, index) => {
                if(USER_LIST_COLUMN_FORMAT[index].toLowerCase() !== header.toLowerCase()) {
                    correct = false
                }
            })

            return correct
        }

        if(cols.length !== USER_LIST_COLUMN_FORMAT.length) {
            this.uploadErrorSetter({ file: file.uid, message: `${file.name} has invalid column format!` })
            correct_format = false
        } else if (!checkHeaders(headers)) {
            this.uploadErrorSetter({ file: file.uid, message: `${file.name} has invalid column headers!` })
            correct_format = false
        }
        
        if(!correct_format) {
            this.props.uploadingSetter(false)
            this.props.processingSetter(false)
        }
        return correct_format
    }
    // ----------------- END of FILE CHECKING ---------------- //

    clearError = () => {
        this.setState({
            upload_files_error: []
        })
    }

    clearBadData = () => {
        this.setState({
            bad_data: []
        })
    }

    removeErrorAsFileRemoved = (file_uid) => {
        const { upload_files_error } = this.state
        const currentError = []

        upload_files_error.map(error => {
            if(error.file !== file_uid) {
                currentError.push(error)
            }
        })

        this.setState({
            upload_files_error: currentError
        })
    }

    removeFile = (uid) => {
        const { uploadedFiles } = this.props
        const currentFiles = []

        uploadedFiles.map(file => {
            if(file.uid !== uid) {
                currentFiles.push(file)
            }
        })

        this.removeErrorAsFileRemoved(uid)
        this.props.uploadedFilesSetter(currentFiles)
    }

    uploadUsersFromMultipleFiles = () => {
        const { uploadedFiles } = this.props
        const format_correct = []

        const processUploadedFiles = async (array) => {
            for ( const item of array ) {
                await ExcelRenderer(item, (err, resp) => {
                    if(err) {
                        console.log(err)
                    } else {
                        if(this.checkFileFormat(item, resp)) {
                            format_correct.push(true)
                        } else {
                            format_correct.push(false)
                        }
                        
                    }
                })
            }

            if(!_.includes(format_correct, false)) {
                const processUploadedFilesAgain = async (array) => {
                    for (const item of array) {
                        await ExcelRenderer(item, (err, resp) => {
                            if(err) {
                                console.log("ERR: ", err)
                            }
                            this.mergeData(item, resp)
                        })
                    }

                    this.onUpload(this.props.processed_data)
                    this.props.processingSetter(false)
                    this.props.uploadingSetter(true)
                }

                processUploadedFilesAgain(uploadedFiles)
            }
            
        }

        processUploadedFiles(uploadedFiles)

    }

    uploadUser = () => {
        const { uploadedFiles } = this.props

        ExcelRenderer(uploadedFiles[0], (err, resp) => {
            if(err) { console.log(err) }
            else {
                if(this.checkFileFormat(uploadedFiles[0], resp)) {
                    this.processData(resp)
                }
            }
        })
    }

    mergeData = (file, data) => {
        const { rows } = data
        const currentProcessed = this.props.processed_data
        const rowsWithContent = []

        rows.map((row, index) => {
            if(row.length > 0 && index > 0) {
                rowsWithContent.push(row)
            }
        })

        rowsWithContent.map(row => {
            currentProcessed.push(row)
        })

        this.props.processedDataSetter(currentProcessed)
    } 

    processData = (data) => {
        const { rows } = data
        const rowsWithContent = []

        rows.map((row, index) => {
            if(row.length > 0 && index > 0) {
                rowsWithContent.push(row)
            }
        })

        this.onUpload(rowsWithContent)
    }

    filterData = (data) => {
        const goodData = []
        const badData = []

        const validateEmail = (emailField) => {
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (reg.test(emailField) == false) {
                return false
            }
            return true
        }

        const emailTrimmer = (email) => {
            if(typeof email !== 'string') {
                return email
            } else {
                return email.trim().replace(/\s+/g, '')
            }
        }

        data.map(datum => {
            const checkIfIncomplete = (array) => {
                if(array.includes(undefined) || array.length != USER_LIST_COLUMN_FORMAT.length) {
                    return true
                } else {
                    return false
                }
            }

            if(checkIfIncomplete(datum)) {
                badData.push({
                    data: datum,
                    error: UPLOAD_DATA_ERROR[0]
                })
            } else if (!validateEmail(emailTrimmer(datum[1]))) {
                badData.push({
                    data: datum,
                    error: UPLOAD_DATA_ERROR[1]
                })
            } else {
                goodData.push(datum)
            }
        })

        this.setState({
            bad_data: badData
        })

        return goodData
    }
    
    uploadErrorSetter = (error) => {
        const currentError = this.state.upload_files_error

        currentError.push(error)

        this.setState({
            upload_files_error: currentError
        })
    }

    loader = () => {
        const divHolder = []

        divHolder.push(
            <React.Fragment>
                <div className="container">
                  <div className="item-1"></div>
                  <div className="item-2"></div>
                  <div className="item-3"></div>
                  <div className="item-4"></div>
                  <div className="item-5"></div>
                </div>
            </React.Fragment>
        )

        return divHolder
    }

    process_loader = () => {
        const divHolder = []

        divHolder.push(
            <React.Fragment>
                <div className="process-loader__container">
                    <div className="dank-ass-loader">
                      <div className="row">
                        <div className="arrow up outer outer-18" />
                        <div className="arrow down outer outer-17" />
                        <div className="arrow up outer outer-16" />
                        <div className="arrow down outer outer-15" />
                        <div className="arrow up outer outer-14" />
                      </div>
                      <div className="row">
                        <div className="arrow up outer outer-1" />
                        <div className="arrow down outer outer-2" />
                        <div className="arrow up inner inner-6" />
                        <div className="arrow down inner inner-5" />
                        <div className="arrow up inner inner-4" />
                        <div className="arrow down outer outer-13" />
                        <div className="arrow up outer outer-12" />
                      </div>
                      <div className="row">
                        <div className="arrow down outer outer-3" />
                        <div className="arrow up outer outer-4" />
                        <div className="arrow down inner inner-1" />
                        <div className="arrow up inner inner-2" />
                        <div className="arrow down inner inner-3" />
                        <div className="arrow up outer outer-11" />
                        <div className="arrow down outer outer-10" />
                      </div>
                      <div className="row">
                        <div className="arrow down outer outer-5" />
                        <div className="arrow up outer outer-6" />
                        <div className="arrow down outer outer-7" />
                        <div className="arrow up outer outer-8" />
                        <div className="arrow down outer outer-9" />
                      </div>
                    </div>
                    <div className="process-loader__text-div">Merging Files...</div>
                </div>  
            </React.Fragment>
        )

        return divHolder
    }

    badDataRenderer = () => {
        const { bad_data } = this.state
        const divHolder = []
        const processed = []

        bad_data.map((bad) => {
            const { data } = bad
            processed.push({
                name: data[0],
                email: data[1],
                date_attended: data[2],
                topic: data[3],
                error: bad.error
            })
        })

        const bad_data_column = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: 'Date Attended',
                dataIndex: 'date_attended',
                key: 'date_attended',
                render: (text, record, index) => {
                    return (
                        <div>{text? moment(text).format('LL') : null}</div>
                    )
                }
            },
            {
                title: 'Topic',
                dataIndex: 'topic',
                key: 'topic'
            },
            {
                title: 'Error',
                dataIndex: 'error',
                key: 'error'
            }
        ]

        divHolder.push(
            <React.Fragment>
                <Table 
                    dataSource={processed} 
                    columns={bad_data_column} 
                    pagination={false}
                    className="bad-data__table"
                />
            </React.Fragment>
        )

        return divHolder
    }

    render() {
        const { 
            uploadedFiles,
            uploading,
            uploaded,
            processing 
        } = this.props
        const { 
            upload_files_error,
            bad_data 
        } = this.state

        const self = this

        const DraggerProps = {
            name: 'masterlist',
            multiple: true,
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            onChange(info) {
                self.setState({
                    upload_files_error: []
                })
            },
            action: (file) => {
                const currentUploadedFiles = uploadedFiles

                if(this.checkFileType(file) && !this.checkIfAlreadyUploaded(file)) {
                    currentUploadedFiles.push(file)
                    this.props.uploadedFilesSetter(currentUploadedFiles) 
                }
            },
            showUploadList: false,
            disabled: uploading || processing || uploaded
        }

        return (
            <div className="upload-participants__container">
                <Modal
                    visible={this.state.show_bad_data_modal}
                    title={bad_data.length > 1? `Records not uploaded ( ${bad_data.length} Records )` : `Records not uploaded ( ${bad_data.length} Record )`}
                    closable={false}
                    width={800}
                    footer={
                        <React.Fragment>
                            <Button type='primary'
                                onClick={e => {
                                    this.setState({
                                        show_bad_data_modal: false
                                    })
                                }}
                            >
                                Ok
                            </Button>
                        </React.Fragment>
                    }
                >
                    {this.badDataRenderer()}
                </Modal>
                <Dragger {...DraggerProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    {/* <p className="ant-upload-hint">
                    
                    </p> */}
                </Dragger>
                <div className="upload-participants__info-container">
                    Column format: (Attendee's name, Email Address, Date Attended, Topic)
                </div>
                <div className="upload-participants__uploaded-files-container">
                    {
                        uploadedFiles.map(file => {
                            return (
                                <React.Fragment>
                                    <div className='upload-participants__uploaded-files__file-div'>
                                        <span className="upload-participants__uploaded-files__file-name">
                                            {file.name}
                                        </span>
                                        {uploading || uploaded || processing?
                                            null :   
                                            <Tooltip title="Remove" placement="right">
                                                <span className="upload-participants__uploaded-files__file-remove"
                                                    onClick={e => {
                                                        this.removeFile(file.uid)
                                                    }}
                                                >
                                                    x
                                                </span>
                                            </Tooltip>
                                        }
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                </div>
                {processing? 
                <React.Fragment>
                    <div
                        className="processing-indicator__div"
                    >
                        {this.process_loader()}
                    </div>
                </React.Fragment>
                : null}
                {uploading? 
                <React.Fragment>
                    <div
                        className="uploading-indicator__div"
                    >
                        Uploading {this.loader()}
                    </div>
                </React.Fragment>
                : null}
                {uploaded?
                <React.Fragment>
                    <div
                        className="uploaded-indicator__div"
                    >
                        Uploaded <CheckCircleOutlined className="checked_icon"/>
                    </div>
                </React.Fragment>
                : null}
                {bad_data.length > 0?
                <React.Fragment>
                    <div
                        className="bad-data__button-div"
                    >
                        <span 
                            className="bad-data__button-span"
                            onClick={e => {
                                this.setState({
                                    show_bad_data_modal: true
                                })
                            }}
                        >
                            Records not uploaded
                        </span>
                    </div>
                </React.Fragment>
                : null}
                <div className="upload-participants__error-display__container"
                    style={{
                        display: upload_files_error.length > 0? null : 'none'
                    }}
                >
                    <div className="upload-participants__error-display__header-title">
                        Error! 
                    </div>
                    {
                        upload_files_error.map(error => {
                            return (
                                <React.Fragment>
                                    <div>
                                        <InfoCircleOutlined className="upload-participants__error-display__icon"/>{error.message}
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                    <div className="upload-participants__error-display__close-div">
                        <span 
                            className="upload-participants__error-display__close"
                            onClick={e => {
                                this.setState({
                                    upload_files_error: []
                                })
                            }}
                        >
                            close
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default withApollo(UploadParticipants, { withRef: true })